import { SET_PAYMENT_METHODS } from '../actions/paymentMethods';

export default function paymentMethods(state = { sources: [], isLoading: false }, { type, payload }) {
    switch (type) {
        case SET_PAYMENT_METHODS:
            return {
                data: [...payload],
                isLoading: false
            };
        default:
            return state;
    }
}
